import React, { useState } from 'react';

import {
  Card,
  CardContent,
  CardHeader,
  Avatar,
  Box, CircularProgress,
  CardActions,
  Chip,
  Typography, Tooltip, LinearProgress,
  Checkbox,
} from "@mui/material";
import { motion } from "framer-motion";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { headers } from "../../utils/utils";
import PersonIcon from "@mui/icons-material/Person";

const TicketCard = ({
  index,
  ticketStatus,
  setTicketStatus,
  data,
  tagsList,
  memberList,
  color,
  openTicket,
  icon,
  handleOpen,
  updateTicketStatus,
}) => {
  const displayTags = (selectedTag) => {
    const foundTag = tagsList.find(
      (tag) => tag.id.toString() === selectedTag.toString(),
    );
    return foundTag ? foundTag.value : "-";
  };
  const [hovered, setHovered] = useState(false);

  const displayMembers = (selectedMember) => {
    if (selectedMember) {
      const member = memberList.find(
        (mem) => mem.id.toString() === selectedMember.toString(),
      );
      return member ? member.fullName : "-";
    }
    return "";
  };
  const colors = ["primary", "secondary", "success", "error", "warning", "info"];

  const handleCompleteTask = async (ticketId, type) => {
    const ticket = ticketStatus.find(it => it.id === index)


    console.log("DDDDDDDDDDDDDDD")

    const response = await fetch(
      process.env.REACT_APP_TICKET_SERVER +
      "/ticket/show/" +
      ticketId,
      {
        method: "GET",
        headers: headers(),
      },
    );


    const data = await response.json();

    // Override closedDate if type is "C"
    data.closedDate = type === "C" ? new Date() : null;



    const responseTargetDate = await fetch(
      process.env.REACT_APP_TICKET_SERVER +
      "/ticket/update/" +
      ticketId,
      {
        method: "PUT",
        body: JSON.stringify(data),
        headers: headers(),
      },
    );
    const data1 = await responseTargetDate.json();

    updateTicketStatus(data1);
  };


  const getRemainingDays = (targetDate) => {
    if (!targetDate) return 0;
    const now = new Date();
    const target = new Date(targetDate);
    const diffTime = target - now;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert to days
  };

  const getProgress = (remainingDays, totalDays) => {
    return totalDays > 0 ? ((totalDays - remainingDays) / totalDays) * 100 : 0;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  };
  const remainingDays = getRemainingDays(data.targetDate);
  const delayDays = Math.ceil((new Date(data.closedDate) - new Date(data.targetDate)) / (1000 * 60 * 60 * 24));
  const progress = getProgress(remainingDays, 30);
  const colors1 = ["#ff5252", "#ffb74d", "#66bb6a", "#42a5f5", "#ab47bc"]; // Random colors
  return (
    <div>

      <Card onClick={handleOpen} sx={{ p: 3, borderRadius: 3, boxShadow: 4, position: "relative", minWidth: 320 }}>
        <div onClick={() => openTicket(data.id)}>

          <Typography
            variant="body2"
            fontWeight="bold"
            sx={{ position: "absolute", top: 10, left: 10, fontSize: "0.75rem", color: "gray" }}
          >

            <CalendarTodayIcon sx={{ fontSize: "0.75rem", marginRight: "4px" }} />
            {formatDate(data.createdDate)}
            <br />

          </Typography>


          <Typography
            variant="body2"
            fontWeight="bold"
            sx={{ position: "absolute", top: 10, left: 150, fontSize: "0.75rem", color: "gray" }}
          >
            #{data.code}
          </Typography>




          {data.targetDate && (
            <Box sx={{ position: "absolute", top: 5, right: 10, textAlign: "center", fontSize: 10 }}>
              <Typography
                variant="caption"
                sx={{
                  fontSize: "0.65rem",
                  color: data.closedDate
                    ? delayDays > 0
                      ? "error.main"
                      : "success.main"
                    : remainingDays === 0
                      ? "warning.main"
                      : remainingDays > 5
                        ? "success.main"
                        : "error.main",
                }}
              >
                {data.closedDate
                  ? delayDays > 0
                    ? `Completed ${delayDays} days late`
                    : delayDays < 0
                      ? `Completed ${Math.abs(delayDays)} days early`
                      : "Completed on time"
                  : remainingDays < 0
                    ? `Overdue by ${Math.abs(remainingDays)} days`
                    : `${remainingDays} days left`}
              </Typography>
              <Box width={100} mt={0.5}>
                <LinearProgress
                  variant="determinate"
                  value={progress}
                  sx={{
                    height: 5,
                    borderRadius: 5,
                    bgcolor: "grey.300",
                    "& .MuiLinearProgress-bar": {
                      bgcolor:
                        remainingDays === 0
                          ? "warning.main"
                          : remainingDays > 5
                            ? "success.main"
                            : "error.main",
                    },
                  }}
                />
              </Box>
            </Box>
          )}

          <hr className="hr" />

          <Box mt={-1}>
            <Box display="flex" alignItems="center" gap={1}>
              {/* User Icon */}
              <Avatar sx={{ bgcolor: color }} variant="rounded">
                {icon}
              </Avatar>

              {/* Subject Title */}
              <Typography
                variant="h6"
                fontWeight="500"
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2, // Ensures max 2 lines
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  wordBreak: "break-word",
                  fontSize: "0.8rem",
                  lineHeight: 1.4, // Adjust line spacing for better fit
                }}
              >
                {data.subject || "No Subject"}
              </Typography>
            </Box>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2, // Ensures a maximum of 2 lines
                overflow: "hidden",
                textOverflow: "ellipsis",
                mt: 1,
                fontSize: 12,
                textAlign: data.description ? "left" : "center",
                bgcolor: "grey.100", // Light background color
                borderRadius: 1,
                px: 0, // Padding for better spacing
                py: 0.5,
              }}
            >
              {data.message || "No Description"}
            </Typography>


          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="center" gap={1} mt={2}>
            {/* Tags Section */}
            <Box display="flex" flexWrap="nowrap" overflow="hidden" gap={0.5} flex="1">

              {data.tags.length > 0 ? (
                data.tags.map((tag, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: index * 0.1 }}
                    whileHover={{ scale: 1.1 }}
                  >
                    <Chip
                      label={displayTags(tag)}
                      variant="outlined"
                      size="small"
                      sx={{
                        borderColor: color, // Set gray border color
                        color: color, // Set text color
                        fontSize: 12,


                      }}
                    />
                  </motion.div>
                ))
              ) : (
                <Chip label="No Tags" color={color} sx={{
                  borderColor: color, // Set gray border color
                  color: color, // Set text color
                  fontSize: 12,


                }} size="small" variant="outlined" />
              )}
            </Box>

            {/* Members Section */}
            <Box display="flex" flexWrap="nowrap" overflow="hidden" gap={0.5}>
              {data.memberIds.length > 0 ? (
                data.memberIds.map((member, index) => {
                  const name = displayMembers(member);
                  const formattedName = name.length > 1 ? `${name[0]}${name[name.length - 1]}` : name;


                  return (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.8, delay: index * 0.1 }}
                    >
                      <Chip
                        sx={{
                          fontSize: 10,
                          fontWeight: 400,
                          color: "white",
                          backgroundColor: color,
                          borderRadius: "100%",
                          width: 30,
                          height: 30,
                          left: 0,
                        }}
                        size="small"
                        label={formattedName.toUpperCase()}
                      />
                    </motion.div>
                  );
                })
              ) : (
                ""
              )}
            </Box>

          </Box>
        </div>
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mt: 2, mb: -2 }}>

          <Box
            display="flex"
            alignItems="center"
            gap={1}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            sx={{ cursor: "pointer" }}
          >
            {(data.targetDate || data.closedDate) &&
              <Chip
                onClick={() => handleCompleteTask(data.id, data.closedDate ? "O" : "C")}
                label={
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <CalendarTodayIcon sx={{ fontSize: 12, color: data.closedDate ? "white" : color }} />
                    <Tooltip title={data.closedDate ? `Closed: ${formatDate(data.closedDate)}` : "Mark as Completed"}>
                      <Typography
                        variant="body2"
                        fontSize={12}
                        sx={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: "200px", // Fixed width for text
                          cursor: "pointer",
                          paddingLeft: 1,
                        }}
                      >
                        {data.closedDate ? `Closed: ${formatDate(data.closedDate)}` : formatDate(data.targetDate)}
                      </Typography>
                    </Tooltip>
                    {!data.closedDate && hovered && (
                      <Tooltip title="Mark as Completed">
                        <CheckCircleIcon fontSize="small" color={color} sx={{ cursor: "pointer" }} />
                      </Tooltip>
                    )}
                  </Box>
                }
                size="small"
                sx={{
                  width: "180px", // Fixed width for Chip
                  backgroundColor: data.closedDate ? "green" : "white",
                  borderRadius: "8px",
                  fontSize: 10,
                  fontWeight: "bold",
                  color: data.closedDate ? "white" : color,
                  border: `0.1px solid ${color}`,
                  borderColor: data.closedDate ? "green" : color,
                  padding: "4px 8px",
                  cursor: !data.closedDate ? "pointer" : "default",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: data.closedDate ? "darkgreen" : "#f0f0f0",
                  },
                }}
              />
            }
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            {data.ticketItems.length > 0 && 
            <Box position="relative" display="inline-flex">
              <CircularProgress
                variant="determinate"
                value={(data.ticketItems.filter((item) => item.completed).length / data.ticketItems.length) * 100}
                size={30}
                thickness={5}
                sx={{
                  color: color,

                }}
              />
              <Box
                position="absolute"
                top="50%"
                left="50%"
                sx={{
                  transform: "translate(-50%, -50%)",
                  fontSize: 10,
                  fontWeight:"700",
                  color: data.ticketItems.every((item) => item.completed) ? "success.main" : "text.primary",
                }}
              >
                {data.ticketItems.filter((item) => item.completed).length}/{data.ticketItems.length}
              </Box>
            </Box>
            }
          </Box>


        </Box>

      </Card>
      <br />
    </div>
  );
};

export default TicketCard;
